import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AxiosUrl from "../../../AxiosUrl";
import styles from "./RocketPaymentAPI.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "2px solid #00000038",
  boxShadow: 24,
  p: 2,
  maxHeight: "95vh",
  overflowY: "auto",
  "@media (min-width: 600px)": {
    width: 400,
  },
};

function RocketPaymentAPIModal({
  setRocketApiModal,
  setRefresh,
  Refresh,
  Data,
}) {
  const [RocketAPIKey, setRocketAPIKey] = useState(Data?.RocketAPIKey || "");
  const [RocketSecret, setRocketSecret] = useState(Data?.RocketSecret || "");
  const [loading, setLoading] = useState(false);
  const uid = localStorage.getItem("id");

  const fromData = {
    uid,
    RocketAPIKey,
    RocketSecret,
  };

  const submitDomain = () => {
    setLoading(true);
    if (!RocketAPIKey || !RocketSecret) {
      setLoading(false);
      return toast.error("All fields are required");
    }

    AxiosUrl.post(`/update-domain-new/${uid}`, fromData)
      .then(() => {
        setRefresh(Refresh + 1);
        setRocketApiModal(false);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response.data);
        setLoading(false);
      });
  };

  return (
    <Modal
      open={setRocketApiModal}
      onClose={() => setRocketApiModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableScrollLock={true}
    >
      <Box sx={style}>
        <ToastContainer />
        <div className={styles.titleCloseBtn} style={{ textAlign: "right" }}>
          <Button
            onClick={() => setRocketApiModal(false)}
            style={{ color: "red" }}
          >
            X
          </Button>
        </div>

        <div className={styles.title}>
          <Box sx={{ width: "100%", marginBottom: "10px" }}>
            <TextField
              placeholder="Rocket Api Key"
              fullWidth
              label="Rocket Api Key"
              onChange={(e) => setRocketAPIKey(e.target.value)}
              value={RocketAPIKey}
            />
          </Box>

          <Box sx={{ width: "100%", marginTop: "15px" }}>
            <TextField
              placeholder="Rocket Api Secret"
              fullWidth
              label="Rocket Api Secret"
              onChange={(e) => setRocketSecret(e.target.value)}
              value={RocketSecret}
            />
          </Box>
        </div>

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <Button
            onClick={() => setRocketApiModal(false)}
            variant="outlined"
            style={{ marginRight: 10 }}
          >
            Cancel
          </Button>
          <Button onClick={submitDomain} variant="contained" disabled={loading}>
            {loading ? "Loading.." : "Continue"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default RocketPaymentAPIModal;
